/**
 * Lookup the OnTrack "brand" for a given brand/TOC code
 * The OnTrack "brand" relates to the brand to use for API calls
 */
export const BRANDS = {
  SE: "southeastern",
  TL: "thameslink",
  SN: "southern",
  GN: "greatnorthern",
  GX: "gatwick",
  NRE: "southeastern",
  // use SE brand for NRE,
  SR: "scotrail",
  TB: "ticketyboo",
  TP: "transpennine"
};
/**
 * Brands using the Trainline booking engines
 */

export const TRAINLINE_BRANDS = {
  GA: "greateranglia",
  SR: "scotrail"
};
/**
 * Production URL associated with the OnTrack "brand"
 */

export const BRAND_DOMAIN = {
  SE: "southeasternrailway.co.uk",
  TL: "thameslinkrailway.com",
  SN: "southernrailway.com",
  GN: "greatnorthernrail.com",
  GX: "gatwickexpress.com",
  NRE: "southeasternrailway.co.uk",
  SR: "scotrail.co.uk",
  TB: "www.myticketyboo.com",
  TP: "www.tpexpress.co.uk"
};
export const DEFAULT_LOCAL_ENV = 'stage';
export const API_ACCESS_TOKEN = {
  default: "8gh2w38ho43o83hw48o4hg8h4g8",
  stage: "86512cad76131783f5dae4346ddc3fb39f6f7c0f74b3039bff70ca4015ade034",
  prod: "otrl|a6af56be1691ac2929898c9f68c4b49a0a2d930849770dba976be5d792a"
};